module.exports = __webpack_public_path__ + "img/success.b54601a7.svg";